import imageCompression from 'browser-image-compression';

/**
 * Job photos (spec 019 D32): compressed in the browser to a long side of
 * 1,600 px and about 300 KB, then put on the job's presigned URL. The keys go
 * to `recordJobEvent`.
 */

type Presign = (
  contentType: string,
  contentLength: number,
) => Promise<{ url: string; key: string }>;

export const JOB_PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'];

export async function compressJobPhoto(file: File): Promise<File> {
  try {
    const result = await imageCompression(file, {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 1600,
      useWebWorker: true,
      fileType: 'image/jpeg',
      initialQuality: 0.7,
    });
    return new File([result], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    return file;
  }
}

export async function uploadJobPhotos(files: readonly File[], presign: Presign): Promise<string[]> {
  const keys: string[] = [];
  for (const original of files) {
    if (!original.type.startsWith('image/')) throw new Error('Choose photos only');
    const file = await compressJobPhoto(original);
    const { url, key } = await presign(file.type, file.size);
    const response = await fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });
    if (!response.ok) throw new Error(`Upload failed (${response.status})`);
    keys.push(key);
  }
  return keys;
}
